"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Input;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _style = require("./style");

var _jsxRuntime = require("react/jsx-runtime");

function Input(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.MainContainer, {
    error: props.error,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.InputCustom, (0, _objectSpread2.default)({
      autoFocus: true,
      onChange: function onChange(event) {
        return props.onChange && props.onChange(event.target.value);
      }
    }, props))
  });
}